import { ComponentType, lazy, LazyExoticComponent } from 'react';

const STORAGE_KEY = 'lazy-reloaded-components';

const lazyWithRetry = <T extends ComponentType<never>>(
  importComponent: () => Promise<{ default: T }>
): LazyExoticComponent<T> =>
  lazy<T>(async () => {
    const moduleKey = importComponent.toString();

    const storedModuleKeys: string[] =
      JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || [];

    if (!Array.isArray(storedModuleKeys))
      throw new Error('Invalid session storage format');

    const refreshedModules = new Set<string>(storedModuleKeys);

    const hasModuleRetried = refreshedModules.has(moduleKey);

    try {
      const module = await importComponent();
      refreshedModules.delete(moduleKey);
      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(Array.from(refreshedModules))
      );
      return module;
    } catch (err) {
      if (!hasModuleRetried) {
        refreshedModules.add(moduleKey);
        sessionStorage.setItem(
          STORAGE_KEY,
          JSON.stringify(Array.from(refreshedModules))
        );
        location.reload();
      } else {
        throw err;
      }
    }
  });

export default lazyWithRetry;
